import React, { Component } from "react";
import classnames from "classnames";
import _ from "i18n";

import { TiArrowSortedDown } from "react-icons/ti";
import Slide from "../Dashboard/Slide";

import styles from "./PreparePresentation.local.scss";

class slidePosition extends Component {
  constructor(props) {
    super(props);

    this.state = {
      positionsFilterIsVisible: null,
      page: props.currentIndex,
      initialePosition: props.currentIndex,
      activatedSlide: null
    };
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsidePositionsFilter.bind(this)
    );
  }

  handleDisplayPositionsFilter = id => {
    this.setState({
      positionsFilterIsVisible: this.state.positionsFilterIsVisible ? null : id
    });
  };

  handleClickOutsidePositionsFilter = event => {
    if (
      this.positionsWrapperRef &&
      !this.positionsWrapperRef.contains(event.target)
    ) {
      this.setState({ ...this.state, positionsFilterIsVisible: false });
    }
  };

  getPageOptions = () => {
    const { data } = this.props;
    let nbrOfSlides = data.slides.filter(
      slide =>
        !["QUESTIONS_SLIDE", "THANKING_SLIDE"].includes(slide.layout.type)
    ).length;

    let options = [];
    for (let i = 0; i < nbrOfSlides; i++) {
      let j = i + 1;
      options.push({ label: j, value: i });
    }
    return options;
  };

  setPositionsWrapperRef = node => {
    this.positionsWrapperRef = node;
  };

  handleChangeSlidePage = (selectedPage, slide) => {
    this.setState({
      page: selectedPage ? selectedPage.value : null,
      activatedSlide: slide,
      positionsFilterIsVisible: null
    });
  };

  handleCancelMoveSlide = () => {
    this.setState({
      ...this.state,
      positionsFilterIsVisible: null,
      page: this.props.currentIndex
    });
    this.props.cancelMoveSlide();
  };

  render() {
    const { slide, lng } = this.props;
    let { page, initialePosition, positionsFilterIsVisible } = this.state;
    return (
      <div className={styles.move_sidebar}>
        <div className={styles.title_side_bar}>{_("moveSlideTemplate")}</div>
        <div className={styles.slide_min}>
          <span className={styles.slide_label}>{slide.labels[lng]}</span>
          <div className={styles.slide_frame}>
            <Slide key={slide.id} slide={slide} isResponsive={false} />
            <img
              src={"/img/icons/check-circle.svg"}
              alt={""}
              className={styles.arrow_left}
            />
          </div>
          <div className={styles.slide_position}>
            <span>{_("slidePosition")}</span>
            <div
              className={
                styles.costumed_select +
                " " +
                styles.costumed_select_min +
                " " +
                (positionsFilterIsVisible ? styles.costumed_select_opened : "")
              }
            >
              <div className={styles.costumed_select_header}>
                <span>
                  {this.getPageOptions().find(obj => obj.value === page).label}
                </span>
                <div className={styles.actions}>
                  <div>
                    <span
                      className={styles.action}
                      onClick={() =>
                        this.handleDisplayPositionsFilter(slide.code)
                      }
                    >
                      <TiArrowSortedDown />
                    </span>
                  </div>
                </div>
              </div>
              {positionsFilterIsVisible === slide.code && (
                <div
                  className={styles.costumed_select_body}
                  ref={this.setPositionsWrapperRef.bind(this)}
                >
                  <div className={styles.costumed_select_body_options}>
                    {this.getPageOptions().map((item, index) => (
                      <div
                        key={index}
                        className={styles.costumed_select_body_option}
                        onClick={() => this.handleChangeSlidePage(item)}
                      >
                        {item.label}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={styles.slides_footer}>
          <button
            className={styles.cancel_btn}
            onClick={this.props.cancelMoveSlide}
          >
            {_("cancel")}
          </button>
          <button
            className={classnames(
              styles.validate_btn,
              initialePosition === page && styles.disabled_btn
            )}
            onClick={() => this.props.validateAction(page, initialePosition)}
          >
            {_("validate")}
          </button>
        </div>
      </div>
    );
  }
}

export default slidePosition;



// WEBPACK FOOTER //
// ./src/components/PreparePresentation/SlidePosition.js